<template>
    <div>
        <div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>

            <app-tabela
                idTabela="tblHistoricoJobIntegracao"
                :itens="historico"
                :campos="campos"
                :itensPorPagina="itensPorPagina"
                :bordered="false"
                :small="false"
            >
                <template slot="data" slot-scope="{ data }">
                    {{
                        data
                            ? $moment(data).format('DD/MM/YYYY HH:mm')
                            : 'Data não disponível'
                    }}
                </template>
            </app-tabela>
        </div>
    </div>
</template>

<script>
export default {
    components: {},

    props: {
        contrato: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            erros: [],
            campos: [
                {
                    key: 'data',
                    label: 'Data',
                    sortable: true,
                    type: 'datetime'
                },
                {
                    key: 'usuario',
                    label: 'Usuário',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'situacaoAnterior',
                    label: 'Situação Anterior',
                    filterable: true
                },
                {
                    key: 'situacaoPosterior',
                    label: 'Situação Posterior',
                    filterable: true
                },
                {
                    key: 'acao',
                    label: 'Ação',
                    filterable: true
                },
                {
                    key: 'observacao',
                    label: 'Observação',
                    filterable: true
                }
            ],
            itensPorPagina: 10
        }
    },

    computed: {
        historico() {
            return this.contrato && this.contrato.historicoJobIntegracao
                ? this.contrato.historicoJobIntegracao
                : []
        }
    }
}
</script>
